// src/components/Select.js
import React from 'react';

const Select = ({
  label,
  value,
  onChange,
  name,
  required = false,
  options = [],
  error,
  className = '',
  placeholder = '',
  ...props
}) => {
  return (
    <div className="mb-4">
      {label && (
        <label
          className="block text-sm font-medium text-content-secondary mb-1"
          htmlFor={name}
        >
          {label}
          {required && <span className="text-risk-critical ml-1">*</span>}
        </label>
      )}
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        style={{ colorScheme: 'inherit' }}
        className={`
          w-full px-3 py-2 rounded-lg
          bg-input-bg border
          text-content-primary
          focus:outline-none focus:ring-2 focus:ring-accent-cyan/50 focus:border-accent-cyan
          transition-colors
          ${error ? 'border-risk-critical' : 'border-border'}
          ${className}
        `}
        {...props}
      >
        {placeholder && (
          <option value="" disabled style={{ backgroundColor: 'var(--bg-secondary)', color: 'var(--text-primary)' }}>
            {placeholder}
          </option>
        )}
        {options.map(option => (
          <option
            key={option.value}
            value={option.value}
            style={{ backgroundColor: 'var(--bg-secondary)', color: 'var(--text-primary)' }}
          >
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <p className="mt-1 text-sm text-risk-critical">{error}</p>
      )}
    </div>
  );
};

export default Select;
